import PricedropFilledCvna from '@carvana/ds-icons/PricedropFilledCvna';
import { icon } from '@carvana/ds-styles';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { VehiclePrice } from './VehicleLinkCard.styles';

type OwnProps = {
  hasPriceDrop: boolean;
  isNewVehicle: boolean;
  msrp: number;
  previousPrice?: number;
  total: number;
};

export default function Price({
  hasPriceDrop,
  isNewVehicle,
  msrp,
  previousPrice,
  total
}: OwnProps) {
  const showPreviousPrice = hasPriceDrop && !isNewVehicle && previousPrice;
  const showMsrp = isNewVehicle;

  return (
    <div className="flex flex-col" data-testid="vdp-link-vehicle-price">
      <div className="flex items-center gap-md">
        {showPreviousPrice && (
          <PricedropFilledCvna
            aria-hidden="true"
            size={16}
            color={icon.success}
          />
        )}

        <VehiclePrice>${total.toLocaleString()}</VehiclePrice>
      </div>

      {showMsrp && (
        <span className="text-text-default t-body-sm">
          MSRP{' '}
          <span className="line-through">${formatAndDropDecimal(msrp)}</span>
        </span>
      )}

      {showPreviousPrice && (
        <span className="text-text-default t-body-sm">
          was{' '}
          <span className="line-through">
            ${previousPrice.toLocaleString()}
          </span>
        </span>
      )}
    </div>
  );
}
